import { React, useState, useEffect, forwardRef, useImperativeHandle, useRef } from 'react'
import { Button } from 'antd-mobile'
import http from '../../../utils/http.js'

import GrammaList from "./ModeList/GrammaList.js"
import WordList from "./ModeList/WordList.js"
import { triggerCallLoading } from '../../../utils/EventBus.js'

const states = require('../../../utils/states.js')






export default forwardRef((props, ref) => {

  const ref_grammaList = useRef(null)
  const ref_wordList = useRef(null)
  const scrollBottom = () => {
    if (states.curBookInfo().bGrammaBook) {
      ref_grammaList.current?.scrollBottom()
    } else {
      ref_wordList.current?.scrollBottom()
    }

  }
  const refreshList = () => {
    if (states.curBookInfo().bGrammaBook) {
      ref_grammaList.current?.refreshList()
    } else {
      ref_wordList.current?.refreshList()
    }
  }
  const refreshItem = (index) => {
    if (states.curBookInfo().bGrammaBook) {
      ref_grammaList.current?.refreshItem(index)
    } else {
      ref_wordList.current?.refreshItem(index)
    }
  }
  const refreshAfterAdd = () => {
    if (states.curBookInfo().bGrammaBook) {
      ref_grammaList.current?.refreshAfterAdd();
    } else {
      ref_wordList.current?.refreshAfterAdd();
    }
  }
  useImperativeHandle(ref, () => ({
    scrollBottom,
    refreshList,
    refreshItem,
    refreshAfterAdd,
  }))
  var bGramma = states.curBookInfo().bGrammaBook;

  return (<>
    {bGramma ?
      <div>
        <GrammaList ref={ref_grammaList} funcs={props.funcs} />
      </div> :
      <div>
        <WordList ref={ref_wordList} funcs={props.funcs} />
      </div>
    }
  </>)

})